export default "__VITE_ASSET__Tl5fE90Z__"